import { UserRoles } from "@/jenesys-types/jenesys-entities/config";

export type UserRole = UserRoles;

const normalize = (value: string): string => value.toUpperCase();

export const roleIsOneOf = (
  role: UserRole | string | undefined,
  roles: Array<UserRole | string>
): boolean => {
  if (!role) return false;
  const roleStr = normalize(String(role));
  return roles.map(String).map(normalize).includes(roleStr);
};

export const roleIsNotOneOf = (
  role: UserRole | string | undefined,
  roles: Array<UserRole | string>
): boolean => !roleIsOneOf(role, roles);

export const RESTRICTED_QUERY_ROLES: Array<UserRole> = [
  UserRoles.COMPANY_USER,
  UserRoles.DAO_USER
];
